import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Input, Row, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createScreen, deleteScreen, fetchTranslation, updateScreen } from "../../../slices/thunks";
import { getAuthUser } from "../../../helpers/utils";
import DeleteModal from "../../../Components/Common/DeleteModal";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import AddCommonForm from "../../../Components/Common/AddCommonForm/AddCommonForm";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";
import { toast } from "react-toastify";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const labels = [
  {
    id: 2,
    labelName: "Screen Name Arabic",
    fieldName: "text-box-translate",
    name: "ScreenNameAr",
    value: "ScreenNameAr",
    required: true,
    errorMessage: "Screen Name Arabic is required",
    minLength: 3,
    minLengthErrorMessage: "ScreenNameMin",
    maxLength: 50,
    maxLengthErrorMessage: "ScreenNameMax",
    translateTo: "ScreenNameEn",
  },
  {
    id: 2,
    labelName: "Screen Name English",
    fieldName: "text-box",
    name: "ScreenNameEn",
    value: "ScreenNameEn",
    required: true,
    errorMessage: "Screen Name English is required",
    translateTo: "ScreenNameAr",
    minLength: 3,
    minLengthErrorMessage: "ScreenNameMin",
    maxLength: 50,
    maxLengthErrorMessage: "ScreenNameMax",
  },
];

const actionConfig = {
  edit: {
    icon: "ri-edit-2-line",
    tooltip: "Edit",
  },
  delete: {
    icon: "ri-delete-bin-2-line",
    tooltip: "Delete",
  },
  // permission: {
  //   icon: "ri-lock-unlock-line",
  //   tooltip: "Permission",
  //   // isVisible: (item) => item.Id != 2,
  // },
};

function ManageScreen({ shows, setScreenTab, permission }) {
  const dispatch = useDispatch();
  const {user} = getAuthUser();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [screen, setScreen] = useState();
  const [lastTranslatedField, setLastTranslatedField] = useState(null); 
  

  const { screens, ScreenTableColumnNames, loading, translationLoading } = useSelector(
    (state) => ({
      screens: state.Localization.screens,
      ScreenTableColumnNames: state.Localization.ScreenTableColumnNames,
      loading: state.Localization.loading, 
      translationLoading: state.Module.translationLoading, 
    })
  );

  const handleClassesClicks = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (localization, value) => {
    setSelectedRow(localization);
    setScreen(localization);
    setIsAddOrEdit(value);
    setShow(true);
  };

  const onChangeHandler = (e) => {
    setScreen((preValue) => ({
      ...preValue,
      [e.target.name]: e.target.value,
    }));
  };

  const confirmDelete = () => {
    dispatch(deleteScreen({ Ids: selectedIds, UserId: user.UserId }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };
  
    const onTranslateClickHandler = (targetField, textToTranslate, formikSetFieldValue, sourceFieldName) => {
      if (!textToTranslate || textToTranslate.trim() === "") {
        toast.error(t("EnterTextToTranslate"));
        return;
      }
      setLastTranslatedField(sourceFieldName); 
  
      dispatch(fetchTranslation({ LangText: textToTranslate }))
        .unwrap() 
        .then(translatedText => {
          formikSetFieldValue(targetField, translatedText);
        })
        .catch(error => {
          console.error("Translation error:", error);
          toast.error(t("TranslationFailed"));
        })
        .finally(() => {
          setLastTranslatedField(null); 
        });
    };
  

  const onSubmitScreenHandler = (values, { resetForm }) => {
    const screenObj = {
      ScreenNameEn: values.ScreenNameEn.trim(),
      ScreenNameAr: values.ScreenNameAr.trim(),
    };
  
    if (isAddOrEdit === "isEdit") {
      screenObj.ID = selectedRow.ID; 
      screenObj.IsActive = selectedRow.IsActive; 
    }
  
    if (isAddOrEdit === "isAdd") {
      dispatch(createScreen(screenObj));  
    } else {
      dispatch(updateScreen(screenObj));  
    }
    resetForm();
    setShow(false);
  };
  

  return (
    shows && (
      <>
        {/* <div
          className="position-relative cursor-pointer"
          onClick={() => setScreenTab(false)}
        >
          <i
            className="position-absolute end-0 ri-close-circle-line fs-24"
            style={{ top: "-38px" }}
          ></i>
        </div> */}

        <div className="table-responsive">
          <Card>
            <CardHeader>
              <Row className="g-4">
                    <Col className="col-sm-auto">
                      <div>
                        <Button
                        color="secondary"
                        className="add-btn me-1"
                        onClick={() => setScreenTab(false)}
                        id="create-btn"
                        >
                        <i className={`${!isRTL ? "ri-arrow-left-line " : "ri-arrow-right-line "}`+ "align-bottom me-1 ms-1"}/>
                        {/* {t("Back")} */}
                        </Button>
                        <Button
                          className="btn btn-soft-danger ms-2 me-2"
                          onClick={() => setDeleteModal(true)}
                          disabled={selectedIds.length === 0}
                        >
                          <i className="ri-delete-bin-2-line"></i>
                        </Button>
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => handleClassesClicks("isAdd")}
                          disabled={loading}
                          id="create-btn"
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      
                      </div>
                    </Col>
                    <Col className="col-sm">
                      <div className="d-flex justify-content-sm-end">
                        {/* <Button
                          className="btn btn-soft"
                          onClick={() => setModalOpen(true)}
                        >
                          <i className="ri-filter-3-line"></i>
                        </Button> */}
                        <div className="search-box ms-2 me-2">
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={t("Search")}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      </div>
                    </Col>
              </Row>
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
            
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner
                      style={{ height: "3rem", width: "3rem" }}
                      className="me-2"
                    >
                      Loading...
                    </Spinner>
                  </div>
                ) : (
                  // <CommonTable
                  //   data={screens}
                  //   tableColumnNames={ScreenTableColumnNames}
                  //   searchTerm={searchTerm}
                  //   onEditClickHandler={onEditClickHandler}
                  //   setDeleteModal={setDeleteModal}
                  //   setSelectedIds={setSelectedIds}
                  //   permission={permission}
                  // />
                  <CommonDataTable
                    data={screens}
                    tableColumnNames={ScreenTableColumnNames}
                    searchTerm={searchTerm}
                    onEditClickHandler={onEditClickHandler}
                    setDeleteModal={setDeleteModal}
                    setSelectedIds={setSelectedIds}
                    actionConfig={actionConfig}
                    permission={permission}
                  />
                )}
              </div>
            </CardBody>
          </Card>
        </div>

        {/* Modal  */}
        <CommonAddModal
          show={show}
          setShow={setShow}
          onSubmitHandler={onSubmitScreenHandler}
          labels={labels}
          isAddOrEdit={isAddOrEdit}
          selectedItemData={selectedRow}
          FormBody={AddCommonForm}
          FormBodyProps={{ onTranslateClickHandler, translationLoading, lastTranslatedField }} 
          title={isAddOrEdit === "isAdd" ? t("AddNewScreen") : t("EditScreen")}
          size="lg"
       />

        {/* Delete modal  */}
        <DeleteModal
          showDelete={deleteModal}
          setShowDelete={setDeleteModal}
          onDeleteClick={confirmDelete}
          setSelectedIds={setSelectedIds}
          description={t("confirmDelete")}
        />
      </>
    )
  );
}

export default ManageScreen;
